export default __webpack_public_path__ + "static/media/bankVerificationhelpHighlight@2x.77ad4c60.png";